import type { RespostasPersonalizadasIzzaModel, CampoRespostaIzza } from "../models/respostasPersonalizadasIzzaModel"

export enum RespostasPersonalizadasIzzaActionsTypes {
    CARREGAR = "CARREGAR",
    ATUALIZAR_RESPOSTA = "ATUALIZAR_RESPOSTA",
    TOGGLE_ATIVO = "TOGGLE_ATIVO",
    TOGGLE_AVALIACAO = "TOGGLE_AVALIACAO",
    SET_MODO_IZZA = "SET_MODO_IZZA",
    TOGGLE_INDICACAO = "TOGGLE_INDICACAO",
    SET_TEXTO_INDICACAO = "SET_TEXTO_INDICACAO",
}

export type RespostasPersonalizadasIzzaActionModel =
    | {
          type: RespostasPersonalizadasIzzaActionsTypes.CARREGAR
          payload: RespostasPersonalizadasIzzaModel
      }
    | {
          type: RespostasPersonalizadasIzzaActionsTypes.ATUALIZAR_RESPOSTA
          payload: { campo: CampoRespostaIzza; resposta: string }
      }
    | {
          type: RespostasPersonalizadasIzzaActionsTypes.TOGGLE_ATIVO
          payload: { campo: CampoRespostaIzza }
      }
    | {
          type: RespostasPersonalizadasIzzaActionsTypes.TOGGLE_AVALIACAO
      }
    | {
          type: RespostasPersonalizadasIzzaActionsTypes.SET_MODO_IZZA
          payload: { modoIzza: number }
      }
    | {
          type: RespostasPersonalizadasIzzaActionsTypes.TOGGLE_INDICACAO
      }
    | {
          type: RespostasPersonalizadasIzzaActionsTypes.SET_TEXTO_INDICACAO
          payload: { texto: string }
      }
